import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import { Typography } from '@material-ui/core';

class TenureChip extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        className: PropTypes.string,
        tenure: PropTypes.oneOf(['Freehold', 'Leasehold', 'Unregistered', 'Unknown']).isRequired
    };

    constructor (props) {
        super(props);
        this.getTenureClassName = this.getTenureClassName.bind(this);
    }

    getTenureClassName () {
        const { classes, tenure } = this.props;
        switch (tenure) {
            case 'Freehold':
                return classes.freehold;
            case 'Leasehold':
                return classes.leasehold;
            case 'Unregistered':
            case 'Unknown':
                return classes.unknown;
        }
    }

    render () {
        const { classes, className, tenure } = this.props;

        return (
            <Typography
                className={
                    classnames(
                        classes.tenure,
                        this.getTenureClassName(),
                        className
                    )
                }
            >
                {tenure}
            </Typography>
        );
    }
}

const style = theme => ({
    tenure: {
        ...theme.typography.chip,
        textTransform: 'uppercase',
        minWidth: '75px',
        width: '75px'
    },
    leasehold: {
        color: theme.palette.warning.main,
        background: `${theme.palette.warning.main}33`
    },
    freehold: {
        color: theme.palette.success.main,
        background: `${theme.palette.success.main}33`
    },
    unknown: {
        color: theme.palette.secondary.light,
        background: `${theme.palette.secondary.light}33`
    }
});

export default withStyles(style)(TenureChip);